import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from '@phosphor-icons/react';
import { ButtonCommon, AnimationCommon, TopHeader } from 'components/common';
import useAuthContext from 'stores/auth-context';
interface CardItem {
  id: string;
  title: string;
  description: string;
  previewUrl: string;
  navigateTo: string;
}

interface OverviewCommonProps {
  items: CardItem[];
  username?: string;
}

const OverviewCommon: React.FC<OverviewCommonProps> = ({ items }) => {
  const { profile } = useAuthContext();
  return (
    <>
      <TopHeader
        title={`Xin chào${profile?.data ? ', ' + profile?.data.baseUser.name + '!' : ''}`}
        subTitle='Bạn có thể chọn 1 trong các tính năng bên dưới để sử dụng'
      />

      <div className=' px-4  py-4'>
        <div className='grid grid-cols-1  lg:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-6 xl:gap-8 2xl:gap-12'>
          {items.map((item, index) => (
            <AnimationCommon
              key={item.id}
              className=' rounded-3xl border-b-[1.5px] border-[var(--textBlack8)] bg-[var(--bgGreyColor3)] overflow-hidden 2xl:min-w-[480px] 2xl:max-w-[580px] 2xl:h-[335px] transition-shadow duration-300 '
              effect='zoomFadeRight'
              transition='slow'
              delay={index * 0.15}
            >
              <div className='p-5 flex justify-between items-start bg-white'>
                <div>
                  <h3 className='2xl:text-lg xl:text-base font-bold '>{item.title}</h3>
                  <p className='2xl:text-sm xl:text-xs text-[var(--textBlack56)] mt-1'>{item.description}</p>
                </div>

                <Link to={item.navigateTo} className='flex items-center'>
                  <ButtonCommon color='soft' size='md' radius='rounded' className='hover:shadow-sm whitespace-nowrap'>
                    <span className='flex items-center gap-2'>
                      <ArrowUpRight size={16} weight='regular' /> Truy cập
                    </span>
                  </ButtonCommon>
                </Link>
              </div>

              <div className='h-[230px] relative overflow-hidden'>
                <iframe
                  src={item.previewUrl}
                  title={item.title}
                  className='absolute w-[250%] h-[250%] scale-[0.4] border-0 rounded-3xl overflow-hidden '
                  loading='lazy'
                  scrolling='no'
                  style={{
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                    transformOrigin: 'top left',
                    border: 'none',
                    pointerEvents: 'none',
                  }}
                />
              </div>
            </AnimationCommon>
          ))}
        </div>
      </div>
    </>
  );
};

export default OverviewCommon;
